import {ENUM, OBJECT} from '@acng/frontend-rubicon';

import {TIMESTAMP_MS} from './time.js';
import {ALOHA_PARTNER} from './aloha-partner.js';

export const STATE_RESET = 'reset';
export const STATE_REQUESTED = 'requested';
export const STATE_PENDING = 'pending';
export const STATE_CONFIRMED = 'confirmed';
export const STATE_DENIED = 'denied';

export const POSSIBLE_STATES = /** @type {const} */ ([
  STATE_RESET,
  STATE_REQUESTED,
  STATE_PENDING,
  STATE_CONFIRMED,
  STATE_DENIED,
]);

/**
 * @typedef {Valid<typeof FRIENDSHIP>} Friendship
 */

export const FRIENDSHIP_STATE = /* @__PURE__ */ ENUM(POSSIBLE_STATES);

export const FRIENDSHIP = /* @__PURE__ */ OBJECT({
  partner: ALOHA_PARTNER,
  status: FRIENDSHIP_STATE,
  timestamp_ms: TIMESTAMP_MS,
});
